angular.module('main').directive('input', () => ({
	restrict: 'E',
	priority: -1,
	link(scope, element, attrs) {
		function init() {
			$(element).updatePolyfill();
		}

		switch (attrs.type) {
			case 'number':
				init();
				break;
			case 'date':
				init();
				break;
			default:
				return false;
		}
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Elements/webshimPolyfill.js